import React from "react";
import { color, radius, space } from "../tokens";

/**
 * <Skeleton> — content placeholder while data loads.
 *
 * Use for any load taking >200ms. For faster than 200ms, use a spinner.
 *
 *   variant : "line"   default → single line of text
 *             "block"  → rectangular block
 *             "circle" → round avatar
 *   width, height : override defaults
 *   lines   : for "line" variant, render N stacked lines (last is 60% width)
 */
export function Skeleton({
  variant = "line",
  width,
  height,
  lines = 1,
  style,
}) {
  if (variant === "line" && lines > 1) {
    return (
      <div style={{ display: "flex", flexDirection: "column", gap: space[2], ...style }}>
        {Array.from({ length: lines }).map((_, i) => (
          <SkeletonPiece
            key={i}
            width={i === lines - 1 ? "60%" : width || "100%"}
            height={height || 12}
            radius={radius.sm}
          />
        ))}
      </div>
    );
  }
  if (variant === "circle") {
    const size = width || height || 32;
    return <SkeletonPiece width={size} height={size} radius={radius.pill} style={style} />;
  }
  return (
    <SkeletonPiece
      width={width || "100%"}
      height={height || (variant === "block" ? 80 : 12)}
      radius={variant === "block" ? radius.md : radius.sm}
      style={style}
    />
  );
}

function SkeletonPiece({ width, height, radius: r, style }) {
  return (
    <span
      aria-hidden
      style={{
        display: "inline-block",
        width,
        height,
        borderRadius: r,
        background: `linear-gradient(90deg, ${color.bg.subtle} 0%, ${color.bg.hover} 50%, ${color.bg.subtle} 100%)`,
        backgroundSize: "200% 100%",
        animation: "idz-shimmer 1.2s ease-in-out infinite",
        ...style,
      }}
    />
  );
}
